export default {
  northern: '北部',
  central: '中部',
  southern: '西部',
  eastern: '東部',
  island: '離島',
  overseas: '海外',
  isRequired: '記入必須',
  submitSuccess: 'Success',
  detail: 'Owlting Blockchain Services™について',
  partners: 'Owlting Blockchain Services™ パートナー',
  caseStudy: '異業種の提携事例',
  freeTrial: '無料でお試し',
  contactAndBuy: 'お問い合わせもしくは直接に購入',
  language: '言語',
  aboutUs: 'About Us',
  contactUs: '連絡',
  submit: '送信',
  blockChainDiscovery: 'ブロックチェーン技術は各産業で運用',
  blockChainBenefits: '利点',
  achieveMore: 'さらにOwlting Blockchain Services™ができること',
  customerService: 'Customer Service',
  mailService: 'Mail Us',
  spotlight: 'パートナースポットライト',
  nav: {
    industries: '産業応用',
    contactUs: '連絡'
  },
  hero: {
    title: 'Owlting Blockchain Services™をご利用になると、すぐに問題点が解決できます',
    mobileTitle: ['Owlting Blockchain Services™をご利用になると', 'すぐに問題点が解決できます'],
    description: 'Owlting Blockchain Services™はどんな産業にもブロックチェーン技術を運用できます。より安全で透明性を高めたビジネスプロセスにより、お客様に信頼される商品を作り出し、顧客の信頼を獲得します。'
  },
  form: {
    title: 'ご要望とお客様の連絡先をお知らせください。',
    companyName: '会社名',
    industry: '産業分野',
    name: '連絡先',
    phone: '電話番号',
    email: 'メール',
    description: '使用目的'
  },
  banner: {
    title: 'Owlting Blockchain Services™のパートナーになりませんか！',
    description: '申し込みされたら、係員のほうからすぐにご連絡いたします。カスタマイズのOwlting Blockchain Services™サービスをご提供いたします。'
  },
  cookie: {
    title: '奧丁丁使用隱私權聲明',
    content: 'このウェブサイトはクッキーを使用していい体験に提供しております。クッキーの設定をそのまま変更しないなら、クッキーのことを同意します。詳細についてクッキーのプライバシーを読んでください。',
    more: '詳細な',
    agree: '理解する'
  },
  custom: {
    forestry: {
      title: '行政院農業委員会林務局 x Owlting Blockchain Services™ 製材品生産追跡システム',
      subTitle: '世界初の製材品生産追跡システムの正式利用が開始！',
      content: '合法製材品の生産地識別や違法伐採防止のため、行政院農業委員会林務局はブロックチェーン技術を採用、2019 年 12 月 5 日に Owlting Group と開発協力した「台湾産製材品生産追跡システム」を提唱しました。\n\n「不可逆性」「耐改ざん性」「非中央集権化」というブロックチェーンの最大の特性を生かした世界初の「台湾産製材品生産追跡システム」により、国産製材品の生産過程の追跡が可能になり、生産者と消費者両者の利益確保が可能になります。',
      blockTitle: {
        product: '産品発表記者会見',
        news: 'メディア報道'
      }
    }
  },
  priceTable: {
    Agriculture: {
      projectPrice: 'プロジェクト価格',
      tab01: '生産追跡システムのプラン',
      tab02: ' IoTデバイスサービス',
      tab02Title: ' IoTデバイスサービス（買取り又はリースからお選びいただけます）',
      enterprise: {
        micro: '零細企業',
        small: '小企業',
        medium: '中企業',
        large: '大企業'
      },
      numberOfProducts: '履歴項目',
      services: {
        label: 'サービス内容',
        item01: '商品生産追跡画面',
        item02: 'プラットフォームの設定'
      },
      addons: {
        label: '履歷ステッカーの追加購入',
        firstYearDiscount: '新規契約の場合、1年目のご利用価格をNT3,600引きでご提供いたします。'
      },
      monthlyLeasing: '*月額料金をご利用する場合は最低契約期間が1年となります。',
      weatherStation: {
        name: '微氣象站',
        intro: '最短須租1年，免費保固1年，租滿3年送裝置'
      },
      fieldSensor: {
        name: '土壤檢測',
        intro: '最短須租1年，免費保固1年，租滿2年送裝置'
      },
      gateway: {
        name: '閘道器與基地台',
        intro: '最短須租1年，免費保固1年，租滿2年送裝置'
      }
    },
    applyBtn: 'お申し込み',
    iotBtn: 'お申し込み',
    per: {
      month: '月',
      item: '個',
      pageInclude: '枚(以内)',
      page: '枚'
    }
  },
  cases: {
    riceValley: {
      name: '池上禾榖坊',
      intro: '信頼と安心の台湾ブランド米',
      product: '無農薬白米/玄米'
    },
    passionFruit: {
      name: '台東パッションフルーツ',
      intro: '自然農法・無農薬で栽培',
      product: '無農薬パッションフルーツ'
    },
    oneForTea: {
      name: 'ONE for TEA 一凡茶作',
      intro: '台東鹿野無毒のティーガーデン',
      product: 'レッドウーロン茶/包種茶'
    },
    changbinRice: {
      name: '台東龍岫產米',
      intro: '安心安全なお米 心を込めて栽培',
      product: '有機白米'
    },
    btn: '生産履歴を見る'
  }
}
